module.exports = __webpack_public_path__ + "img/lg_ring_r_c_1_null.3f879562.png";